import { call, put } from 'redux-saga/effects';
import {
  saveBillingDetailsFailure,
  saveBillingDetailsSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { SaveBillingDetailsRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { saveBillingDetails } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import { ApiResponse } from 'store/api/types';
import i18n from 'i18next';
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* saveBillingDetailsSaga(
  action: SaveBillingDetailsRequestAction
) {
  try {
    let err: ApiError | null;
    const { accountId, billingDetails } = action.payload;
    const saveBillingDetailsResponse: ApiResponse = yield call(
      saveBillingDetails,
      accountId,
      billingDetails
    );

    err = checkResponse(saveBillingDetailsResponse?.responseMessage);
    if (err) throw err;

    yield put(saveBillingDetailsSuccess(billingDetails));
    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: saveBillingDetailsResponse?.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    }
    yield put(saveBillingDetailsFailure());
  }
}
